import { BookOpen, Lightbulb } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { Trope } from "@/types/summary";
import { SettingCard } from "./SettingCard";

interface TropeSubcardProps {
  trope: Trope;
  index: number;
}

export function TropeSubcard({ trope, index }: TropeSubcardProps) {
  const { t } = useTranslation("jobDetails");
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <SettingCard
      accentBarClassName="bg-primary-500"
      headerContent={
        <span
          className="text-[0.9375rem] font-semibold text-foreground"
          data-testid={`trope-name-${index}`}
        >
          {trope.name}
        </span>
      }
      preview={trope.reason}
      expandedContent={
        <>
          <div className="space-y-1.5">
            <div className="flex items-center gap-1.5">
              <BookOpen className="w-3.5 h-3.5 text-primary-500" />
              <span className="text-[0.75rem] font-semibold uppercase tracking-wide text-secondary-500">
                {t("tropesCard.description")}
              </span>
            </div>
            <p
              className="text-[0.875rem] leading-5 text-secondary-500 pl-5"
              data-testid={`trope-description-${index}`}
            >
              {trope.description}
            </p>
          </div>

          <div className="space-y-1.5">
            <div className="flex items-center gap-1.5">
              <Lightbulb className="w-3.5 h-3.5 text-primary-500" />
              <span className="text-[0.75rem] font-semibold uppercase tracking-wide text-secondary-500">
                {t("tropesCard.reason")}
              </span>
            </div>
            <p
              className="text-[0.875rem] leading-5 text-secondary-500 pl-5"
              data-testid={`trope-reason-${index}`}
            >
              {trope.reason}
            </p>
          </div>
        </>
      }
      isExpanded={isExpanded}
      onToggle={() => setIsExpanded(!isExpanded)}
      testIds={{
        accentBar: `trope-accent-bar-${index}`,
        toggle: `trope-toggle-${index}`,
        chevronRight: `trope-chevron-right-${index}`,
        chevronDown: `trope-chevron-down-${index}`,
        preview: `trope-preview-${index}`,
        content: `trope-content-${index}`,
      }}
    />
  );
}
